import React from 'react';
import { Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';

const COACHING_PEDAGOGY_ROWS = [
  {
    method: 'Direct Instruction',
    description: 'Traditional, directive approach often used in elite, skill-focused environments, characterized by repetitive drills and rigid structures.',
  },
  {
    method: 'Active Learning',
    description: 'Engaging athletes to think, discover, and actively participate in skill refinement, rather than passive listening.',
  },
  {
    method: 'Inquiry-based Learning',
    description: 'Encouraging learners to ask questions and explore.',
  },
  {
    method: 'Cooperative Learning',
    description: 'Fostering collaboration among students.',
  },
  {
    method: 'Discovery Learning',
    description: 'Actively constructing knowledge rather than passive listening.',
  },
  {
    method: 'Problem-based Learning',
    description: 'Utilizing real-world problems to develop critical thinking.',
  },
  {
    method: 'Game-Based Learning',
    description: 'Using gameplay or modified games to teach technique and tactics, emphasizing context and decision-making.',
  },
  {
    method: 'Positive Relationships',
    description: "Building trust and caring for the athlete's holistic development.",
  },
  {
    method: 'Constraints-Led Approach',
    description: 'Modifying constraints, such as rules, field size, or equipment, to drive learning.',
  },
  {
    method: 'Tailored Instruction',
    description: "Adapting teaching styles to the athlete's developmental stage, age, and learning style.",
  },
] as const;

export function CoachingPedagogyTable() {
  return (
    <Box>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
        Coaching pedagogy describes the teaching methods coaches use to build sport knowledge, player-centered learning, and reflective practice.
      </Typography>
      <TableContainer sx={{ border: '1px solid #bbdefb', borderRadius: 1, bgcolor: '#fff' }}>
        <Table size="small" sx={{ minWidth: 1080 }}>
          <TableHead>
            <TableRow sx={{ bgcolor: '#eef7ff' }}>
              <TableCell sx={{ fontWeight: 700, minWidth: 180 }}>Method</TableCell>
              <TableCell sx={{ fontWeight: 700, minWidth: 360 }}>Description</TableCell>
              <TableCell sx={{ fontWeight: 700, whiteSpace: 'nowrap' }}>Sports Knowledge</TableCell>
              <TableCell sx={{ fontWeight: 700, whiteSpace: 'nowrap' }}>Player Centric</TableCell>
              <TableCell sx={{ fontWeight: 700, whiteSpace: 'nowrap' }}>Reflective Practice</TableCell>
              <TableCell sx={{ fontWeight: 700, whiteSpace: 'nowrap' }}>Learning Video</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {COACHING_PEDAGOGY_ROWS.map((row) => (
              <TableRow key={row.method}>
                <TableCell sx={{ fontWeight: 700 }}>{row.method}</TableCell>
                <TableCell>{row.description}</TableCell>
                <TableCell />
                <TableCell />
                <TableCell />
                <TableCell />
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}
